import { WithRequestDemo } from "../../shared/contact-modal/WithContactUsAttributes";
import { ourSolutionsInfo } from "./ourSolutionsSettings";

const OurSolutionsSection = (settings) => {
    return (
        <div className="py-4 our-solutions">
            <div className="container">
                <div className="row">
                    <div className="col">
                        <span className="section-title section-title-highlight">
                            Our Solutions
                        </span>
                        <span className="section-title d-none d-md-inline-block">Building Management</span>
                    </div>
                </div>
                <div className="row mt-3 g-0 d-flex align-items-stretch">
                    {/* Text Content */}
                    <div className="col-12 col-lg-8">
                        <p dangerouslySetInnerHTML={{ __html: settings.ourSolutionDescription }}>
                        </p>
                        <div className="d-flex flex-column flex-sm-row gap-2">
                            <a className="btn btn-lg d-flex align-items-center justify-content-center btn-primary" href={ourSolutionsInfo.fmPro.brochureUrl} target="_blank" rel="noopener noreferrer">
                                <img
                                    src="/img/our-solutions/map.png"
                                    alt="map"
                                    className="me-1"
                                />
                                Brochure
                            </a>
                            <a className="btn btn-lg d-flex align-items-center justify-content-center btn-outline-primary" href={ourSolutionsInfo.fmPro.videoUrl} target="_blank" rel="noopener noreferrer">
                                <img
                                    src="/img/our-solutions/video.png"
                                    alt="video"
                                    className="me-1"
                                />
                                Video
                            </a>
                        </div>
                        <div className="mt-4">
                            <div className="section-title text-start">Start Your Trial</div>
                            <div className="section-title text-start section-title-highlight d-none d-md-inline-block">
                                Transform Your Business
                            </div>
                        </div>
                        <p dangerouslySetInnerHTML={{ __html: settings.startTrialDescription }}>
                            
                        </p>
                        <div className="d-flex flex-column flex-sm-row gap-2">
                            <button className="btn btn-lg d-flex align-items-center justify-content-center btn-primary" {...WithRequestDemo()}>
                                Request a Trial
                            </button>
                            <button className="btn btn-lg d-flex align-items-center justify-content-center btn-extra-dark" aria-expanded="false" data-bs-toggle="modal" data-bs-target="#contactUsModal">
                                <img
                                    src="/img/our-solutions/contact-us.png"
                                    alt="video"
                                    className="me-1"
                                />
                                Contact Us
                            </button>
                        </div>
                    </div>
                    
                    {/* Image Section */}
                    <div className="col-lg-4 d-none d-lg-flex align-items-stretch px-3">
                        <div className="w-100 h-100">
                            <a href={ourSolutionsInfo.fmPro.brochureUrl} target="_blank" rel="noopener noreferrer">
                                <img
                                    src="/img/our-solutions/brochure-first-page.png"
                                    alt="Our Solutions"
                                    className="img-fluid h-100 w-100"
                                    style={{ objectFit: "contain" }}
                                />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OurSolutionsSection;